import React,{Component} from "react";
import Slider from "./sliderRAS";
// import "./sliderRAS/css/horizontal.css";
import "./sliderRAS/css/vertical.css";
import "normalize.css/normalize.css";
import "./sliderRAS/css/slider-animations.css";
import "./sliderRAS/css/styles.css";
import {content} from"./Data";
import {
  Popup,
  //Button,
} from "semantic-ui-react"; 

class WellcomeBanner extends Component {

  state={
    showPlay: false, showStop: true
  }
  sliderRef;

  componentDidMount() {
    this.timerID = setInterval(this.sliderRef.next, 10000);
  }

  componentWillUnmount() {
    if (this.timerID) {
      clearInterval(this.timerID);
    }
  }

  // *** show play or stop button of slider control
   showPlayButton = () => {
    this.setState({ ...this.state,showPlay: true, showStop: false });
  };
  // *** show play or stop button of slider control
   showStopButton = () => {
    this.setState({ ...this.state, showPlay: false, showStop: true });
  };
  
    renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };
  // ******
   next = () => {
    this.sliderRef.next();
  };
   previous = () => {
    this.sliderRef.previous();
  };
   play = () => {
    this.timerID = setInterval(this.sliderRef.next, 1000);
    this.showStopButton()
  };
   pause = () => {
    if (this.timerID) {
          clearInterval(this.timerID);
        }
        this.showPlayButton()
  };
   renderPlayStopButton = () =>{
    if(this.state.showPlay){
      return(
        <Popup
  content={"Play"}
  disabled={this.renderPopupState()}
  trigger={
    <span 
    className="icon-button-gr"
    onClick={this.play}    
    >
    <img  src='/play.png' alt=" " style={{width:"50px", height:"50px",borderRadius:'5px',verticalAlign:'middle'}} />
    </span>
  }
/>
    
      )
    }
    if(this.state.showStop){
      return(
        <Popup
  content={"Stop"}
  disabled={this.renderPopupState()}
  trigger={
    <span 
    className="icon-button-gr"
    onClick={this.pause}
    >
    <img  src='/stop.png' alt=" " style={{width:"50px", height:"50px",borderRadius:'5px',verticalAlign:'middle'}} />
    </span>
  }
/>
      
      )
    }
  }
  
  //^^^^^^^^^^
  //*************** */
  render(){
    return (
      <>
      <div className='bg-dark'>

<Slider 
className="slider-wrapper "
//autoplay='5000'
ref={ref => (this.sliderRef = ref)}>
      {content.map((item, index) => (
        <div
          key={index}
          className="slider-content "
          style={{ background: `url('${item.image}') no-repeat center center` }}
        >
          <div className="inner flex-center  direction-column" style={{paddingTop:'25px'}}>
            <h1 className="text-shadow" style={{color:'gold'}}>{item.title}</h1>
            <p   style={{textAlign:'justify)'}} className="heading-2 font-family-Nunito text-align-justify maxWidth-600">{item.description}</p>
            {/* <button 
            onClick = {this.props.handleContactUsModal}
            className = 'nodisplay-at-tab'><b>{item.button}</b></button> */}
          <p style={{color:'aqua',textAlign:'justify)'}} className="heading-2 maxWidth-600">{item.description2}</p>
          
          </div>
          {/* <section>
            <img src={item.userProfile} alt={item.user} />
            <span>
              Posted by <strong>{item.user}</strong>
            </span>
          </section> */}
        </div>
      ))}
    </Slider>
    </div>
    <div>
    <div className="flex-center" style={{ textAlign: "center" }}>
      <Popup
  content={"Previous"}
  disabled={this.renderPopupState()}
  trigger={
    <span 
    className="icon-button-gr"
    onClick={this.previous}
    >
    <img  src='/pre.png' alt=" " style={{width:"50px", height:"50px",borderRadius:'5px',verticalAlign:'middle'}} />
    </span>
  }
/>
     
    {this.renderPlayStopButton()}
    <Popup
  content={"Next"}
  disabled={this.renderPopupState()}
  trigger={
    <span 
    className="icon-button-gr"
    onClick={this.next}
    >
    <img  src='/next.png' alt=" " style={{width:"50px", height:"50px",borderRadius:'5px',verticalAlign:'middle'}} />
    </span>
  }
/>
       
        
      </div>
    

</div>
</>
    );
  }
}


export default WellcomeBanner
